import { render } from "./changes-in-past-rent.vue?vue&type=template&id=2edfa826&scoped=true&lang=pug"
import script from "./changes-in-past-rent.vue?vue&type=script&lang=js"
export * from "./changes-in-past-rent.vue?vue&type=script&lang=js"

import "./changes-in-past-rent.vue?vue&type=style&index=0&id=2edfa826&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2edfa826"]])

export default __exports__